import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import RecoverPass from "../pages/auth/RecoverPass";
import SingIn from "../pages/auth/SingIn";
import NotFound from "../pages/main/NotFound";
import PrivateRoute from "./PrivateRoute";
import { getAuth } from "../redux/auth/actions";
import ChangePass from "../pages/profile/changePass";
import Relatives from "../pages/Headcount/Relatives";
import JobPosition from "../pages/Headcount/JobPosition";
import crudAreas from "../pages/Headcount/CrudAreas";
import Jobs from "../pages/Headcount/Jobs";
import Users from "../pages/Headcount/Users";
import DashboardH from "../pages/Headcount/HeadcountDashboard";
import Health from "./employeeDetails/Health";
import Employees from "../pages/Headcount/Employees";
import Education from "./employeeDetails/Education";
import EmployeeDetail from "../pages/Headcount/staffInventory/EmployeeDetail";
import DashboardPositionH from "../pages/Headcount/HeadcountPositionDashboard";
import Settings from "../pages/main/Settings";
import AdminSettings from "../pages/maintenance/Settings";
import EmergencyContanct from "../pages/Headcount/EmergencyContanct";
import Orgs from "../pages/Headcount/Orgs";
import SecurityBeneficers from "../pages/Headcount/SecurityBeneficers";
import EquipmentAsign from "../pages/Headcount/EquipmentAssignation";
import JobStory from "../pages/Headcount/JobStory";
import AcademicStory from "../pages/Headcount/AcademicStory";
import Specialization from "../pages/Headcount/Specialization";
import CurrentSituation from "../pages/Headcount/CurrentSituation";
import OrgsforStaffInventory from "../pages/Headcount/staffInventory/OrgsforStaffInventory";
import EmployeeTab from "../pages/Headcount/staffInventory/EmployeeTab";
import GeneralInfo from "./employeeDetails/GeneralInfo";
import FuncOrganizationalStructure from "../pages/Headcount/structures/FuncOrganizationalStructure";
import FuncEmployeedStructure from "../pages/Headcount/structures/FuncEmployeedStructure";
import Emergency from "./employeeDetails/Emergency";
import Dependants from "./employeeDetails/Dependants";
import FuncStaffInventory from "../pages/Headcount/staffInventory/funcional/FuncStaffInventory";
import JobHistory from "./employeeDetails/JobHistory";
import Institute from "../pages/Headcount/Institute";
import CollegeDegree from "../pages/Headcount/CollegeDegree";
import HealthManteinance from "../pages/Headcount/HealthManteinance";
import FuncFormation from "../pages/maintenance/formation/FuncFormation";
import PersonalDivision from "../pages/Headcount/PersonalDivision";
import Diagnosis from "../pages/Headcount/Diagnosis";
import EducationFunc from "../pages/maintenance/education/EducationFunc";
import DashboardIndPlazContJefes from "../pages/Headcount/DashboardIndPlazContJefes";
import OrgsForEmployees from "../pages/Headcount/OrgsForEmployees";
import AccessDenied from "../pages/main/AccessDenied";
import UserInfo from "../pages/profile/UserInfo";
import RemeUpdate from "../pages/profile/RemeUpdate";
// import FormDocuments from "../pages/maintenance/documents/DocumentsChecklist";
import EmployeeDocsChecklist from "../pages/maintenance/documents/EmployeeDocsChecklist";
import Laboratories from "../pages/maintenance/Laboratories";
import Vaccines from "../pages/maintenance/Vaccines";
import EmployeesVaccines from "../pages/maintenance/EmployeesVaccines";
import CheckListEmp from "./employeeDetails/CheckListEmp";
import Docs from "./employeeDetails/Docs";
import Division from "../pages/Headcount/Division";
import Tasks from "../pages/maintenance/Tasks";
import Classification from "../pages/Headcount/Classification";
import EmployeedTimes from "../pages/Headcount/EmployeedTimes";
import LoginReport from "../pages/Headcount/LoginReport";
import GestionTiempos from "../pages/Headcount/gestionTiempos";
import workflowRoutes from "../pages/OnBoarding_OffBoarding/WorkFlow.Router";
import climaRoutes from "../pages/climalaboral/Clima.Router";
import SanctionRoutes from "../pages/Modulo_Sanciones/Sanction.Router";
import GeneralRoutes from "../pages/general/General.Router";
import DashboardWfhPowerBI from "../pages/Headcount/dashboardWfhPowerBI";
import DescriptorProfilesRouter from "../pages/descriptorsProfiles/DescriptorsProfiles.router";
import SeleccionContratacionRouter from "../pages/seleccionContratacion/SeleccionContratacion.router";
import EvaluacionDesempenio from "../pages/evaluacion_desempenio/EvaluacionDesempenio.router";
import NotificationsRouter from "../pages/notifications/Notifications.router";
import MarcajePowerBI from "../pages/Headcount/MarcajePowerBI";
import CapacitacionDesarrolloRouter from "../pages/capacitacion_Desarrollo/capacitacionDesarrollo.router";
// import CountryMaintenance from "../pages/maintenance/location/CountryMaintenance";
// import DepartmentMaintenance from "../pages/maintenance/location/DepartmentMaintenance";
// import MunicipalityMaintenance from "../pages/maintenance/location/MunicipalityMaintenance";
import CostCenterMaintenance from "../pages/maintenance/costCenter/CostCenterMaintenance";
import MaintenanceRoutes from "../pages/maintenance/Maintenance.router";
import HeadcountRoutes from "../pages/Headcount/Headcount.router";
import CarreraSucesionRouter from "../pages/Carrera_Sucesion/CarreraSucesion.router";
import VacationsRouter from '../pages/vacations/vacations.router';
import NueveCajasRouter from "../pages/nueveCajas/NueveCajas.router";
import PlanCarreraRouter from "../pages/planCarrera/PlanCarrera.router";
import SurveyRouter from "../pages/survey/survey.router";
import ModuloNotificacionesRouter from "../pages/Modulo_Notificaciones/ModuloNotificaciones.router";
// import MarcajeCTM from "../pages/Headcount/MarcajeCTM";
// import { getNotifications } from "../redux/notifications/actions";

function App() {
  // const userId = useSelector((store) => store.auth.id);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAuth());
  }, [dispatch]);

  // useEffect(() => {
  //   if (userId && userId != " ") {
  //     dispatch(
  //       getNotifications({
  //         limit: 10,
  //         offset: 0,
  //         id_destinatario: parseInt(userId),
  //         leido: 0,
  //       })
  //     );
  //   }
  // }, [dispatch, userId]);

  return (
    <Router>
      <Switch>
        <Route
          path="/"
          component={SingIn}
          roles={["administrador", "jefe", "empleado"]}
          exact
        />
        <Route path="/recuperarcontrasenia" component={RecoverPass} exact />
        {/*Config url*/}
        <PrivateRoute
          path="/Cambiar-contrasenia"
          roles={["administrador", "jefe", "empleado"]}
          component={ChangePass}
          exact
        />
        {/* <PrivateRoute
          path="/cargos/:type"
          roles={["administrador"]}
          component={JobPosition}
          exact
        /> */}
        <PrivateRoute
          path="/plazas/:type"
          roles={["administrador"]}
          component={Jobs}
          exact
        />
        <PrivateRoute
          path="/asignacion-de-equipo/:id/:name/:type"
          roles={["administrador"]}
          component={EquipmentAsign}
          exact
        />
        <PrivateRoute
          path="/historial-laboral/:id/:name/:type"
          roles={["administrador"]}
          component={JobStory}
          exact
        />
        <PrivateRoute
          path="/historial-academico/:id/:name/:type"
          roles={["administrador"]}
          component={AcademicStory}
          exact
        />
        {/* <PrivateRoute
          path="/unidad/:type"
          roles={["administrador"]}
          component={crudAreas}
          exact
        /> */}
        <PrivateRoute
          path="/usuarios"
          roles={["administrador"]}
          component={Users}
          exact
        />
        <PrivateRoute
          path="/configuracion"
          roles={["administrador"]}
          component={Settings}
          exact
        />
        <PrivateRoute
          path="/contactos-emergencia/:id/:name/:type"
          roles={["administrador"]}
          component={EmergencyContanct}
          exact
        />
        {/* <PrivateRoute
          path="/especializacion/:type"
          roles={["administrador"]}
          component={Specialization}
          exact
        /> */}
        <PrivateRoute
          path="/situacion-actual/:type"
          roles={["administrador"]}
          component={CurrentSituation}
          exact
        />
        {/* <PrivateRoute
          path="/institutos/:type"
          roles={["administrador"]}
          component={Institute}
          exact
        /> */}
        {/* <PrivateRoute
          path="/titulo/:type"
          roles={["administrador"]}
          component={CollegeDegree}
          exact
        /> */}
        {/* <PrivateRoute
          path="/clasificación/:type"
          roles={["administrador"]}
          component={Classification}
          exact
        /> */}
        <PrivateRoute
          path="/salud-mantenimiento/:id/:name/:type"
          roles={["administrador"]}
          component={HealthManteinance}
          exact
        />
        {/* <PrivateRoute
          path="/division/:type"
          roles={["administrador"]}
          component={Division}
          exact
        /> */}
        {/* <PrivateRoute
          path="/division-personal/:type"
          roles={["administrador"]}
          component={PersonalDivision}
          exact
        /> */}
        {/* <PrivateRoute
          path="/diagnosticos/:type"
          roles={["administrador"]}
          component={Diagnosis}
          exact
        /> */}
        <PrivateRoute
          path="/mantenimiento-laboratorios/:type"
          roles={["administrador"]}
          component={Laboratories}
          exact
        />
        {/*<PrivateRoute
          path="/mantenimiento-vacunas/:type"
          roles={["administrador"]}
          component={Vaccines}
          exact
        />*/}
        {/* <PrivateRoute
          path="/mantenimiento-documentacion/:type"
          roles={["administrador"]}
          component={FormDocuments}
          exact
        /> */}
        <PrivateRoute
          path="/documentacion-empleados/:type/:id/:name"
          roles={["administrador", "jefe", "empleado"]}
          component={EmployeeDocsChecklist}
          exact
        />
        <PrivateRoute
          path="/func-formacion/:type"
          roles={["administrador"]}
          component={FuncFormation}
          exact
        />
        <PrivateRoute
          path="/vacunas-empleados/:type/:id/:name"
          roles={["administrador", "jefe", "empleado"]}
          component={EmployeesVaccines}
          exact
        />
        <PrivateRoute
          path="/educacion-emp/:id/:name/:type"
          roles={["administrador"]}
          component={EducationFunc}
          exact
        />
        {/* <PrivateRoute
          path="/empleados/:id/:name/:oType/:searchtype/:filter/:searchFilter"
          roles={["administrador"]}
          component={Employees}
          exact
        /> */}
        {/*HeadCount URL*/}
        {/* <PrivateRoute
          path="/detalle-empleado/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={EmployeeDetail}
          exact
        /> */}
        {/* <PrivateRoute
          path="/ficha-empleado/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={EmployeeTab}
          exact
        /> */}
        {/* <PrivateRoute
          path="/general-info-empleado/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={GeneralInfo}
          exact
        /> */}
        {/* <PrivateRoute
          path="/empleado-familiares/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={Dependants}
          exact
        /> */}
        {/* <PrivateRoute
          path="/empleado-contactos-emergencia/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={Emergency}
          exact
        /> */}
        {/* <PrivateRoute
          path="/empleado-salud/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={Health}
          exact
        /> */}
        {/* <PrivateRoute
          path="/empleado-docs/:id/:type"
          roles={["administrador", "jefe", "empleado"]}
          component={Docs}
          exact
        /> */}
        {/* <PrivateRoute
          path="/empleado-educacion/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={Education}
          exact
        /> */}
        <PrivateRoute
          path="/inventario-de-personal/:id/:name/:searchtype/:filter/:type/:filterType"
          roles={["administrador", "jefe", "alta_direccion"]}
          component={FuncStaffInventory}
          exact
        />
        <PrivateRoute
          path="/familiares-dependientes/:id/:name/:type"
          roles={["administrador", "jefe", "empleado"]}
          component={Relatives}
          exact
        />
        <PrivateRoute
          path="/familiares-beneficiarios-seguro/:id/:name/:type"
          roles={["administrador", "jefe", "empleado"]}
          component={SecurityBeneficers}
          exact
        />
        {/* <PrivateRoute
          path="/empleado-tiempos/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={EmployeedTimes}
          exact
        /> */}
        {/*Encuestas clima laboral*/}
        {climaRoutes.map((cRoute) =>
          cRoute.type === "private" ? (
            <PrivateRoute
              path={cRoute.path}
              roles={cRoute.roles}
              component={cRoute.component}
              exact
            />
          ) : (
            <Route path={cRoute.path} component={cRoute.component} exact />
          )
        )}
        {/* Fin encuestas clima laboral */}
        <PrivateRoute
          path="/Dashboard-Headcount"
          roles={["administrador", "jefe", "empleado"]}
          component={DashboardH}
          exact
        />
        <PrivateRoute
          path="/estructura-organizacional/:org/:name/:type"
          roles={["administrador", "alta_direccion"]}
          component={FuncOrganizationalStructure}
          exact
        />
        <PrivateRoute
          path="/dashboard-plazas-y-contrataciones-jefes"
          roles={["jefe", "administrador"]}
          component={DashboardPositionH}
          exact
        />
        {/* <PrivateRoute
          path="/gestión-de-tiempos"
          roles={["administrador", "jefe"]}
          component={GestionTiempos}
          exact
        /> */}
        <PrivateRoute
          path="/empresas/:type"
          roles={["administrador", "alta_direccion"]}
          component={Orgs}
          exact
        />
        <PrivateRoute
          path="/estructura-unidad/:id/:unidad/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={FuncEmployeedStructure}
          exact
        />
        <PrivateRoute
          path="/filtrar-empresas/:id"
          roles={["administrador", "alta_direccion"]}
          component={OrgsforStaffInventory}
          exact
        />
        {/* <PrivateRoute
          path="/empleado-historial-laboral/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={JobHistory}
          exact
        /> */}
        {/* <PrivateRoute
          path="/usuario-documentos/:id/:type"
          roles={["administrador", "jefe", "empleado", "alta_direccion"]}
          component={CheckListEmp}
          exact
        /> */}
        {/* <PrivateRoute
          path="/dashboard-plazas-cont-admin"
          roles={["administrador", "alta_direccion"]}
          component={DashboardIndPlazContJefes}
          exact
        /> */}
        <PrivateRoute
          path="/wfh-teletrabajo"
          roles={["administrador", "jefe", "Responsable_Headcount"]}
          component={DashboardWfhPowerBI}
          exact
        />
        {/* <PrivateRoute
          path="/marcaje-ctm"
          roles={["administrador", "jefe"]}
          component={MarcajeCTM}
          exact
        /> */}
        <PrivateRoute
          path="/reloj-marcador"
          roles={["administrador", "jefe", "Responsable_Headcount"]}
          component={MarcajePowerBI}
          exact
        />
        {/* <PrivateRoute
          path="/empresas-filtro-empleados/:type"
          roles={["administrador"]}
          component={OrgsForEmployees}
          exact
        /> */}
        <PrivateRoute
          path="/administrador-configuracion"
          roles={["administrador"]}
          component={AdminSettings}
          exact
        />
        {/* Pais, departamento, municipio */}
        {/* <PrivateRoute
          path="/country-maintenance"
          roles={["administrador"]}
          component={CountryMaintenance}
          exact
        /> */}
        {/* <PrivateRoute
          path="/department-maintenance"
          roles={["administrador"]}
          component={DepartmentMaintenance}
          exact
        /> */}
        {/* <PrivateRoute
          path="/municipality-maintenance"
          roles={["administrador"]}
          component={MunicipalityMaintenance}
          exact
        /> */}
        {/* Fin Pais, departamento, municipio */}
        {/* Mantenimiento Centro de Costo */}
        {/* <PrivateRoute
          path="/cost-center-maintenance"
          roles={["administrador"]}
          component={CostCenterMaintenance}
          exact
        /> */}
        {/* Mantenimiento Centro de Costo */}
        <PrivateRoute
          path="/reporte-inicio-sesión"
          roles={["administrador"]}
          component={LoginReport}
          exact
        />
        {/* <PrivateRoute
          path="/tareas/:type"
          roles={["administrador"]}
          component={Tasks}
          exact
        /> */}
        {MaintenanceRoutes.map((mRoute) =>
          mRoute.type === "private" ? (
            <PrivateRoute
              path={mRoute.path}
              roles={mRoute.roles}
              component={mRoute.component}
              exact={mRoute.exact}
            />
          ) : (
            <Route path={mRoute.path} component={mRoute.component} exact />
          )
        )}
        {HeadcountRoutes.map((hRoute) =>
          hRoute.type === "private" ? (
            <PrivateRoute
              path={hRoute.path}
              roles={hRoute.roles}
              component={hRoute.component}
              exact={hRoute.exact}
            />
          ) : (
            <Route path={hRoute.path} component={hRoute.component} exact />
          )
        )}
        {workflowRoutes.map((wRoute) =>
          wRoute.type === "private" ? (
            <PrivateRoute
              path={wRoute.path}
              roles={wRoute.roles}
              component={wRoute.component}
              exact={wRoute.exact}
            />
          ) : (
            <Route
              path={wRoute.path}
              component={wRoute.component}
              exact={wRoute.exact}
            />
          )
        )}
        {/*Modulo de sanciones*/}
        {SanctionRoutes.map((sRoute) =>
          sRoute.type === "private" ? (
            <PrivateRoute
              path={sRoute.path}
              roles={sRoute.roles}
              component={sRoute.component}
              exact={sRoute.exact}
            />
          ) : (
            <Route
              path={sRoute.path}
              component={sRoute.component}
              exact={sRoute.exact}
            />
          )
        )}
        {/* Fin modulo de sanciones */}
        {GeneralRoutes.map((gRoute) =>
          gRoute.type === "private" ? (
            <PrivateRoute
              path={gRoute.path}
              roles={gRoute.roles}
              component={gRoute.component}
              exact={gRoute.exact}
            />
          ) : (
            <Route
              path={gRoute.path}
              component={gRoute.component}
              exact={gRoute.exact}
            />
          )
        )}
        {DescriptorProfilesRouter.map((dpRouter) =>
          dpRouter.type === "private" ? (
            <PrivateRoute
              path={dpRouter.path}
              roles={dpRouter.roles}
              component={dpRouter.component}
              exact={dpRouter.exact}
            />
          ) : (
            <Route
              path={dpRouter.path}
              component={dpRouter.component}
              exact={dpRouter.exact}
            />
          )
        )}
        {SeleccionContratacionRouter.map((scRouter) =>
          scRouter.type === "private" ? (
            <PrivateRoute
              path={scRouter.path}
              roles={scRouter.roles}
              component={scRouter.component}
              exact={scRouter.exact}
            />
          ) : (
            <Route
              path={scRouter.path}
              component={scRouter.component}
              exact={scRouter.exact}
            />
          )
        )}
        {EvaluacionDesempenio.map((evRouter) =>
          evRouter.type === "private" ? (
            <PrivateRoute
              path={evRouter.path}
              roles={evRouter.roles}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          ) : (
            <Route
              path={evRouter.path}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          )
        )}
        {NotificationsRouter.map((nRouter) =>
          nRouter.type === "private" ? (
            <PrivateRoute
              path={nRouter.path}
              roles={nRouter.roles}
              component={nRouter.component}
              exact={nRouter.exact}
            />
          ) : (
            <Route
              path={nRouter.path}
              component={nRouter.component}
              exact={nRouter.exact}
            />
          )
        )}
        {CapacitacionDesarrolloRouter.map((evRouter) =>
          evRouter.type === "private" ? (
            <PrivateRoute
              path={evRouter.path}
              roles={evRouter.roles}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          ) : (
            <Route
              path={evRouter.path}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          )
        )}
        {CarreraSucesionRouter.map((evRouter) =>
          evRouter.type === "private" ? (
            <PrivateRoute
              path={evRouter.path}
              roles={evRouter.roles}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          ) : (
            <Route
              path={evRouter.path}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          )
        )}
        {
          VacationsRouter.map((vRouter) =>
            vRouter.type === 'private' ? (
              <PrivateRoute
                path={vRouter.path}
                roles={vRouter.roles}
                component={vRouter.component}
                exact={vRouter.exact}
              />
            ) : (
              <Route
                path={vRouter.path}
                component={vRouter.component}
                exact={vRouter.exact}
              />
            )
          )
        }

        {NueveCajasRouter.map((evRouter) =>
          evRouter.type === "private" ? (
            <PrivateRoute
              path={evRouter.path}
              roles={evRouter.roles}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          ) : (
            <Route
              path={evRouter.path}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          )
        )}

        {PlanCarreraRouter.map((evRouter) =>
          evRouter.type === "private" ? (
            <PrivateRoute
              path={evRouter.path}
              roles={evRouter.roles}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          ) : (
            <Route
              path={evRouter.path}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          )
        )}
        {SurveyRouter.map((route) =>
          route.type === "private" ? (
            <PrivateRoute
              path={route.path}
              roles={route.roles}
              component={route.component}
              exact={route.exact}
            />
          ) : (
            <Route
              path={route.path}
              component={route.component}
              exact={route.exact}
            />
          )
        )}
        {ModuloNotificacionesRouter.map((evRouter) =>
          evRouter.type === "private" ? (
            <PrivateRoute
              path={evRouter.path}
              roles={evRouter.roles}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          ) : (
            <Route
              path={evRouter.path}
              component={evRouter.component}
              exact={evRouter.exact}
            />
          )
        )}
        <PrivateRoute
          path="/perfil-usuario/:id/:type"
          roles={"*"}
          component={UserInfo}
          exact
        />
        <Route path="/accesso-denegado" component={AccessDenied} exact />
        <Route
          path="/recordatorio-actualizacion"
          component={RemeUpdate}
          exact
        />
        <Route path="*" component={NotFound} />
      </Switch>
    </Router>
  );
}

export default App;
